import { forwardRef, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';
import { LocationsApi } from '../../../api/locations.api';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return LocationsComponent; }),
    multi: true
};
var LocationsComponent = /** @class */ (function () {
    function LocationsComponent(fuseTranslationLoaderService, locationsApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.locationsApi = locationsApi;
        this.appearance = 'outline';
        this.locations = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        if (this.required) {
            this.inputValue.setValidators(ValidateAutocomplete);
        }
    }
    LocationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.disabled) {
            this.inputValue.disable();
        }
        this.inputValue.valueChanges.pipe(debounceTime(500)).subscribe(function (value) {
            _this.locations = [];
            if (value) {
                _this.searchLocations(value);
            }
        });
    };
    LocationsComponent.prototype.ngOnChanges = function (changes) {
        for (var propertyName in changes) {
            if (propertyName === 'disabled') {
                this.disabled = changes[propertyName].currentValue;
                if (this.disabled) {
                    this.inputValue.disable();
                }
                else {
                    this.inputValue.enable();
                }
            }
        }
    };
    LocationsComponent.prototype.searchLocations = function (searchTerm) {
        var _this = this;
        this.loading = true;
        this.locationsApi
            .search({ formattedAddressOrDocumentNumber_contains: searchTerm, archived: false }, {
            orderLegacy: false,
            orderColumn: 'formattedAddress',
            order: 'asc',
            offset: 0,
            operator: 'distance',
            value: searchTerm,
            limit: 10
        })
            .subscribe(function (result) {
            _this.loading = false;
            _this.locations = result.items;
        });
    };
    LocationsComponent.prototype.writeValue = function (locationId) {
        var _this = this;
        if (locationId) {
            this.locationsApi.searchOne(locationId).subscribe(function (location) {
                _this.selectedLocation = location;
                _this.inputValue.setErrors(null);
            });
        }
        else {
            this.deselectLocation();
        }
    };
    LocationsComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    LocationsComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    LocationsComponent.prototype.setSelectedLocation = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.selectedLocation = this.locations.find(function (location) { return location.id === _this.inputValue.value; });
            this.onChange(this.inputValue.value);
            this.inputValue.setErrors(null);
        }
    };
    LocationsComponent.prototype.deselectLocation = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedLocation = null;
        this.inputValue.setErrors(null);
    };
    return LocationsComponent;
}());
export { LocationsComponent };
